module.exports = __webpack_public_path__ + "static/banner_web-d76ee0ba3140f4aa870984cfaf574b63.jpg";